import { selectColumn } from "@stories/atoms/SpreadSheet/SpreadSheetSelect";
import { checkboxColumn, keyColumn, textColumn } from "react-datasheet-grid";

import {
  EmployeeSocialProcurementFactor,
  EmploymentType,
  Gender,
  NewExistingJobType,
  OccupationType,
  employeeSocialProcurementFactorToString,
  employmentTypeToString,
  existingJobTypeToString,
  genderToString,
  occupationTypeOptionToString,
} from "@interfaces/employee";

export const getEmployeeColumns = (loading: boolean) => {
  const commitments = Object.values(EmployeeSocialProcurementFactor);
  const columns = [
    {
      ...keyColumn("employeeName", textColumn),
      title: "Employee Name",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      sx: {
        fontWeight: "2rem",
      },
      minWidth: 200,
    },
    {
      ...keyColumn(
        "gender",
        selectColumn(
          {
            options: Object.values(Gender).map((g) => {
              return { value: g, label: genderToString(g) };
            }),
          },
          ({ rowData, value }) => {
            switch (value) {
              default:
                return null;
              case genderToString(Gender.Male):
                return Gender.Male;
              case genderToString(Gender.Female):
                return Gender.Female;
              case genderToString(Gender.Other):
                return Gender.Other;
            }
          }
        )
      ),
      title: "Gender",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    },
    {
      ...(keyColumn("postCode", textColumn) as any),
      title: "Postcode",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    },
    {
      ...(keyColumn("primaryEmployer", textColumn) as any),
      title: "Primary Employer",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    },
    {
      ...(keyColumn("occupation", textColumn) as any),
      title: "Occupation",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    },
    {
      ...keyColumn(
        "occupationType",
        selectColumn(
          {
            options: Object.values(OccupationType).map((o) => {
              return {
                value: o,
                label: occupationTypeOptionToString(o),
              };
            }),
          },
          ({ rowData, value }) => {
            switch (value) {
              default:
                return null;
              case occupationTypeOptionToString(OccupationType.TradeRole):
                return OccupationType.TradeRole;
              case occupationTypeOptionToString(
                OccupationType.NonTradePosition
              ):
                return OccupationType.NonTradePosition;
              case occupationTypeOptionToString(
                OccupationType.ManagementSupervisorSpecialistLabourRoles
              ):
                return OccupationType.ManagementSupervisorSpecialistLabourRoles;
              case occupationTypeOptionToString(OccupationType.Other):
                return OccupationType.Other;
            }
          }
        )
      ),
      title: "Occupation Type",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    },
    {
      ...keyColumn(
        "newExistingJob",
        selectColumn(
          {
            options: Object.values(NewExistingJobType).map((j) => {
              return {
                value: j,
                label: existingJobTypeToString(j),
              };
            }),
          },
          ({ rowData, value }) => {
            switch (value) {
              default:
                return null;
              case existingJobTypeToString(NewExistingJobType.Existing):
                return NewExistingJobType.Existing;
              case existingJobTypeToString(NewExistingJobType.New):
                return NewExistingJobType.New;
            }
          }
        )
      ),
      title: "New/Existing Job",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    },
    {
      ...keyColumn(
        "employmentType",
        selectColumn(
          {
            options: Object.values(EmploymentType).map((e) => {
              return {
                value: e,
                label: employmentTypeToString(e),
              };
            }),
          },
          ({ rowData, value }) => {
            switch (value) {
              default:
                return null;
              case employmentTypeToString(EmploymentType.FullEmployment):
                return EmploymentType.FullEmployment;
              case employmentTypeToString(EmploymentType.Apprentice):
                return EmploymentType.Apprentice;
              case employmentTypeToString(EmploymentType.Trainee):
                return EmploymentType.Trainee;
              case employmentTypeToString(EmploymentType.Cadet):
                return EmploymentType.Cadet;
            }
          }
        )
      ),
      title: "Employment Type",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    },
  ];

  for (const sc of commitments) {
    columns.push({
      ...(keyColumn(`${sc}`, checkboxColumn) as any),
      title: employeeSocialProcurementFactorToString(sc),
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    });
  }

  return columns;
};
